// Central data for L'Atelier Loraine B website
export const HELLOASSO_URL = "https://www.helloasso.com/associations/mon-association-l-atelier";
export const HELLOASSO_SUMMER_STAGE_URL = "https://www.helloasso.com/associations/mon-association-l-atelier/evenements/summer-stage";
export const HELLOASSO_MASTERCLASS_URL = "https://www.helloasso.com/associations/mon-association-l-atelier/evenements/stage-d-impro-les-roles-feminins-comment-renverser-nos-habitudes-dans-l-impro";
export const HELLOASSO_CMI_EARLY_BIRD_URL = "https://www.helloasso.com/associations/mon-association-l-atelier/evenements/offre-early-bird-stage-comedie-musicale-improvisee";
export const HELLOASSO_SAMEDIS_CREATIFS_URL = "https://www.helloasso.com/associations/mon-association-l-atelier/evenements/samedis-creatifs";
export const CONTACT_EMAIL = "association.latelierlb@gmail.com";
export const PHONE = "06 12 47 33 10";
export const PHONE_TEL = "0612473310";

export const PASTELS = ["#FFD6C9", "#C4F4E4", "#E6D7FF", "#FFF3B0", "#C9E8FF", "#FFD1DC"];

export const activities = [
  {
    id: "stages-cmi",
    title: "Stages Comédie Musicale Improvisée",
    subtitle: "3 week-ends de formation · Pack Early Bird jusqu'au 10 octobre",
    dates: "7-8 nov · 20-21 mars · 29-30 mai",
    topSticker: "Early Bird jusqu'au 10 oct",
    earlyBird: "Early Bird en cours — jusqu'au 10 oct",
    credit: "© Maria Tilly",
    image: "/images/stages-cmi.jpg",
    imagePosition: "center top",
    color: "#C4F4E4",
    details: {
      heading: "Comédie Musicale Improvisée — qu'est-ce que c'est ?",
      body: "La CMI mêle improvisation théâtrale, chant et danse. En petits groupes, on improvise en direct des scènes musicales avec personnages, chansons et chorégraphies : un mini-spectacle créé entièrement sur le moment, accompagné par un·e musicien·ne live. C'est exigeant, joyeux, libérateur — et personne ne ressort indemne (dans le bon sens du terme). Le pack 3 week-ends offre une vraie progression sur l'année.",
    },
    cta: { label: "Réserver en Early Bird", href: HELLOASSO_CMI_EARLY_BIRD_URL, type: "helloasso" },
  },
  {
    id: "masterclass",
    title: "Masterclass",
    subtitle: "Théâtre d'improvisation · Rôles féminins · Places limitées",
    dates: "12 décembre · Maison des Femmes · Urrugne",
    topSticker: "Nouvelle édition le 12 décembre",
    earlyBird: "On remet ça !",
    credit: "",
    image: "/images/masterclass.jpg",
    imagePosition: "center 22%",
    color: "#C9E8FF",
    details: {
      heading: "Masterclass — qu'est-ce que c'est ?",
      body: "Une session intensive dirigée autour du théâtre d'improvisation, construite à chaque édition autour d'un thème très spécifique (par exemple : les rôles féminins, le silence, le drame, l'absurde…). Format court (½ journée à 1 journée), petit groupe, travail en profondeur. Idéal pour pousser sa pratique, explorer un angle nouveau, ou simplement se challenger sur une journée. Places très limitées — réservation indispensable.",
    },
    cta: { label: "Réserver ma place", href: HELLOASSO_MASTERCLASS_URL, type: "helloasso" },
  },
  {
    id: "samedis-creatifs",
    title: "Samedis Créatifs",
    subtitle: "Danse contemp. · Parents-enfants · Chorégraphie",
    dates: "28 nov · 23 jan · 6 mars",
    credit: "© Maria Tilly",
    image: "/images/samedis-creatifs.jpg",
    imagePosition: "center top",
    color: "#E6D7FF",
    details: {
      heading: "Samedis Créatifs — qu'est-ce que c'est ?",
      body: "Une matinée en deux temps. On commence par un atelier autour de la danse et de l'éveil musical parents-enfants — un moment partagé, ludique et sensoriel. Puis, place à 2h d'atelier de danse contemporaine ouvert aux danseur·euse·s de tous niveaux, du·de la débutant·e au·à la confirmé·e : exercices d'échauffement, travail technique et atelier chorégraphique pour construire ensemble.",
    },
    cta: { label: "S'inscrire sur HelloAsso", href: HELLOASSO_SAMEDIS_CREATIFS_URL, type: "helloasso" },
  },
  {
    id: "coaching",
    _hidden: true,
    title: "Coaching personnalisé",
    subtitle: "Mouvement, expression, renforcement · Sur mesure",
    dates: "1h/semaine · Studio, ext. ou domicile",
    credit: "© Maria Tilly",
    image: "/images/coaching-loraine.jpg",
    color: "#FFD1DC",
    details: {
      heading: "Coaching personnalisé — qu'est-ce que c'est ?",
      body: "Un accompagnement individuel sur-mesure, taillé à vos objectifs : retrouver le mouvement après une période sédentaire, gagner en présence scénique, préparer une prise de parole, libérer votre expression corporelle, ou simplement bouger pour le plaisir. Séance hebdomadaire d'1h en studio, en extérieur ou à domicile (sur Saint-Jean-de-Luz et alentours). Premier échange offert pour définir ensemble vos envies.",
    },
    cta: {
      label: "Premier échange offert",
      href: `mailto:${CONTACT_EMAIL}?subject=Demande%20de%20coaching%20personnalis%C3%A9&body=Nom%20%3A%0AT%C3%A9l%C3%A9phone%20%3A%0ADisponibilit%C3%A9s%20%3A`,
      type: "mailto",
    },
  },
  {
    id: "stages-impro",
    _hidden: true,
    title: "Stages d'impro",
    subtitle: "Improvisation théâtrale · Vacances scolaires",
    dates: "19-20-21 oct · 19-20-21 avr",
    credit: "",
    image: "/images/stages-impro.jpg",
    color: "#FFD6C9",
    details: {
      heading: "Stages d'impro — qu'est-ce que c'est ?",
      body: "Pendant les vacances scolaires, je propose plusieurs cours d'improvisation adaptés à chaque profil : Improvisation Loisirs, Improvisation Spectacle, Théâtre et Impro Enfants et Théâtre et Impro Ados. Que vous soyez débutant·e curieux·se, amateur·rice régulier·ère ou en préparation de scène, il y a un format pour vous. Personnages, écoute, jeu collectif, lâcher prise — on apprend en jouant.",
    },
    cta: { label: "S'inscrire sur HelloAsso", href: HELLOASSO_URL, type: "helloasso" },
  },
  {
    id: "ateliers-scolaires",
    _hidden: true,
    title: "Ateliers scolaires & entreprises",
    subtitle: "Expression corporelle · Écoles & entreprises",
    dates: "Sur demande",
    credit: "© Maria Tilly",
    image: "/images/ateliers-scolaires.jpg",
    color: "#FFF3B0",
    details: {
      heading: "Ateliers scolaires & entreprises — qu'est-ce que c'est ?",
      body: "Interventions sur mesure en milieu scolaire (écoles, collèges, lycées) ou en entreprise. À la carte selon vos besoins : expression corporelle, improvisation théâtrale, cohésion d'équipe, gestion du stress, prise de parole, créativité collective. Format atelier ponctuel, cycle annuel, ou séminaire team building. Devis personnalisé sur demande.",
    },
    cta: {
      label: "Demander un devis",
      href: `mailto:${CONTACT_EMAIL}?subject=Demande%20de%20devis%20-%20Atelier%20scolaire`,
      type: "mailto",
    },
  },
];

export const spectacles = [
  {
    id: "nebuleuse",
    title: "Nébuleuse",
    type: "Solo · Danse & théâtre · 27 min",
    description:
      "Un solo sur les violences domestiques et le harcèlement intrafamilial — suivi d'un temps d'échange professionnel.",
    nextDate: "Prochaine date : 21 nov · en partenariat avec la Maison des Femmes d'Urrugne",
    credit: "© Louis Triol",
    image: "/images/nebuleuse.jpg",
    href: `mailto:${CONTACT_EMAIL}?subject=Infos%20%26%20programmation%20-%20N%C3%A9buleuse`,
  },
  {
    id: "bienvenue",
    title: "Bienvenue chez nous",
    type: "Spectacle d'improvisation",
    description: "Un show d'impro qui déconstruit, qui dérange, et qui fait rire — sans s'excuser.",
    credit: "",
    image: "/images/bienvenue-chez-nous.jpg",
    href: `mailto:${CONTACT_EMAIL}?subject=Infos%20%26%20programmation%20-%20Bienvenue%20chez%20nous`,
  },
  {
    id: "musicale",
    title: "Musicale et Radicale",
    type: "Solo · Musical & engagé",
    description: "Une création musicale et engagée — entre chant, mouvement et parole vive.",
    credit: "© Zabaldunarae",
    image: "/images/musicale-et-radicale.jpg",
    href: `mailto:${CONTACT_EMAIL}?subject=Infos%20%26%20programmation%20-%20Musicale%20et%20Radicale`,
  },
];

export const events2026 = [
  {
    id: "cmi-early-bird",
    title: "Early Bird · Stages CMI",
    dates: "Jusqu'au 10 oct",
    location: "En ligne · HelloAsso",
    description:
      "Dernière ligne droite pour l'Early Bird des 3 week-ends de Comédie Musicale Improvisée. Tarif préférentiel réservé aux plus rapides — ça se termine le 10 octobre.",
    earlyBird: "À saisir vite",
    cta: { label: "Je réserve mon Early Bird", href: HELLOASSO_CMI_EARLY_BIRD_URL },
    color: "#C4F4E4",
  },
  {
    id: "nebuleuse-urrugne",
    title: "Nébuleuse",
    dates: "21 nov",
    location: "Urrugne · Maison des Femmes",
    description:
      "Représentation du solo Nébuleuse en partenariat avec la Maison des Femmes d'Urrugne — suivie d'un temps d'échange.",
    cta: {
      label: "Infos & billetterie",
      href: `mailto:${CONTACT_EMAIL}?subject=Infos%20%26%20billetterie%20-%20N%C3%A9buleuse%2021%20novembre%20Urrugne`,
    },
    color: "#FFD1DC",
  },
  {
    id: "masterclass-decembre",
    title: "Masterclass · Rôles féminins",
    dates: "12 décembre",
    location: "Maison des Femmes · Urrugne",
    description:
      "Nouvelle édition de la masterclass théâtre d'improvisation autour des rôles féminins. Places limitées — on remet ça !",
    earlyBird: "Nouvelle date",
    cta: { label: "Réserver ma place", href: HELLOASSO_MASTERCLASS_URL },
    color: "#C9E8FF",
  },
];

export const galleryImages = [
  { src: "/images/gallery-mt-1.jpg", alt: "Duo en répétition", rotate: -2, credit: "© Maria Tilly" },
  { src: "/images/gallery-mt-3.jpg", alt: "Trio en mouvement", rotate: -1, credit: "© Maria Tilly" },
  { src: "/images/gallery-mt-2.jpg", alt: "Improvisation à deux", rotate: 2, credit: "© Maria Tilly" },
  { src: "/images/gallery-mt-4.jpg", alt: "Groupe en mouvement", rotate: 1, credit: "© Maria Tilly" },
  { src: "/images/gallery-mt-5.jpg", alt: "Solo en présence", rotate: 1.5, credit: "© Maria Tilly" },
  { src: "/images/samedis-creatifs.jpg", alt: "Samedis Créatifs", rotate: -1 },
];

export const videos = [
  {
    id: "video-nebuleuse",
    title: "Teaser Nébuleuse",
    embed: "https://www.youtube.com/embed/BOVGvcfv9mQ",
    placeholder: false,
  },
  {
    id: "video-musicale",
    title: "Musicale et Radicale",
    embed: "https://www.youtube.com/embed/lekbzcvdTgs",
    placeholder: false,
  },
];
